class TestimonialsSlider extends HTMLElement {
    constructor() {
      super();
      this.track = this.querySelector('.testimonials-slider__track');
      this.viewport = this.querySelector('.testimonials-slider__viewport');
      this.slides = Array.from(this.querySelectorAll('.testimonials-slider__slide'));
      this.dotsWrapper = this.querySelector('.testimonials-slider__dots');
      this.prevBtn = this.querySelector('.testimonials-slider__arrow--prev');
      this.nextBtn = this.querySelector('.testimonials-slider__arrow--next');
  
      this.currentIndex = 0;
      this.perView = 1;
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = (parseInt(this.dataset.autoplaySpeed, 10) || 5) * 1000;
      this.autoplayTimer = null;
  
      this.isDragging = false;
      this.dragStartX = 0;
      this.dragDeltaX = 0;
      this.activePointerId = null;
  
      this.onResize = this.onResize.bind(this);
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onDragStart = this.onDragStart.bind(this);
      this.onDragMove = this.onDragMove.bind(this);
      this.onDragEnd = this.onDragEnd.bind(this);
    }
  
    connectedCallback() {
      if (!this.slides.length) return;
  
      this.setPerView();
      this.buildDots();
      this.updateSlider();
  
      this.prevBtn.addEventListener('click', this.onPrev);
      this.nextBtn.addEventListener('click', this.onNext);
      window.addEventListener('resize', this.onResize);
  
      this.track.addEventListener('pointerdown', this.onDragStart);
      window.addEventListener('pointermove', this.onDragMove);
      window.addEventListener('pointerup', this.onDragEnd);
  
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
  
      this.startAutoplay();
    }
  
    disconnectedCallback() {
      this.prevBtn.removeEventListener('click', this.onPrev);
      this.nextBtn.removeEventListener('click', this.onNext);
      window.removeEventListener('resize', this.onResize);
      this.track.removeEventListener('pointerdown', this.onDragStart);
      window.removeEventListener('pointermove', this.onDragMove);
      window.removeEventListener('pointerup', this.onDragEnd);
      this.stopAutoplay();
    }
  
    setPerView() {
      const width = window.innerWidth;
      if (width <= 599) {
        this.perView = 1;
      } else if (width <= 989) {
        this.perView = 2;
      } else {
        this.perView = 4;
      }
    }
  
    get maxIndex() {
      return Math.max(0, this.slides.length - this.perView);
    }
  
    buildDots() {
      this.dotsWrapper.innerHTML = '';
      const dotCount = this.maxIndex + 1;
  
      for (let i = 0; i < dotCount; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'testimonials-slider__dot';
        dot.setAttribute('aria-label', `Slayt ${i + 1}`);
        dot.addEventListener('click', () => {
          this.currentIndex = i;
          this.updateSlider();
          this.restartAutoplay();
        });
        this.dotsWrapper.appendChild(dot);
      }
  
      this.dots = Array.from(this.dotsWrapper.children);
    }
  
    updateSlider() {
      if (this.currentIndex > this.maxIndex) this.currentIndex = this.maxIndex;
      if (this.currentIndex < 0) this.currentIndex = 0;
  
      const slideWidth = 100 / this.perView;
      const offset = this.currentIndex * slideWidth;
      this.track.style.transform = `translateX(-${offset}%)`;
  
      this.slides.forEach((slide) => {
        slide.style.flexBasis = `${slideWidth}%`;
      });
  
      if (this.dots) {
        this.dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.currentIndex);
        });
      }
  
      this.updateArrowsVisibility();
  
      this.prevBtn.disabled = this.currentIndex === 0;
      this.nextBtn.disabled = this.currentIndex === this.maxIndex;
    }
  
    updateArrowsVisibility() {
      const isMobile = window.innerWidth <= 599;
      let showArrows;
  
      if (isMobile) {
        // Mobilde 2'den fazla slayt varsa göster
        showArrows = this.slides.length > 2;
      } else {
        // Desktop'ta 4'ten fazla slayt varsa göster
        showArrows = this.slides.length > 4;
      }
  
      this.prevBtn.style.display = showArrows ? '' : 'none';
      this.nextBtn.style.display = showArrows ? '' : 'none';
      this.dotsWrapper.style.display = showArrows ? '' : 'none';
    }
  
    onPrev() {
      this.currentIndex = Math.max(0, this.currentIndex - 1);
      this.updateSlider();
      this.restartAutoplay();
    }
  
    onNext() {
      if (this.currentIndex >= this.maxIndex) {
        this.currentIndex = 0;
      } else {
        this.currentIndex += 1;
      }
      this.updateSlider();
      this.restartAutoplay();
    }
  
    onDragStart(e) {
      if (this.maxIndex === 0) return;
      this.isDragging = true;
      this.dragStartX = e.clientX;
      this.dragDeltaX = 0;
      this.activePointerId = e.pointerId;
      this.track.classList.add('is-dragging');
      this.stopAutoplay();
      if (this.track.setPointerCapture) {
        this.track.setPointerCapture(e.pointerId);
      }
    }
  
    onDragMove(e) {
      if (!this.isDragging || e.pointerId !== this.activePointerId) return;
      this.dragDeltaX = e.clientX - this.dragStartX;
  
      const slideWidth = 100 / this.perView;
      const baseOffset = this.currentIndex * slideWidth;
      const viewportWidth = this.viewport.getBoundingClientRect().width || 1;
      const dragPercent = (this.dragDeltaX / viewportWidth) * 100;
  
      this.track.style.transform = `translateX(-${baseOffset - dragPercent}%)`;
    }
  
    onDragEnd(e) {
      if (!this.isDragging) return;
      if (e && e.pointerId !== undefined && e.pointerId !== this.activePointerId) return;
  
      this.isDragging = false;
      this.track.classList.remove('is-dragging');
  
      if (this.track.releasePointerCapture && this.activePointerId !== null) {
        try {
          this.track.releasePointerCapture(this.activePointerId);
        } catch (err) {
          // pointer already released
        }
      }
      this.activePointerId = null;
  
      const viewportWidth = this.viewport.getBoundingClientRect().width || 1;
      const threshold = viewportWidth * 0.15;
  
      if (this.dragDeltaX > threshold) {
        this.currentIndex = Math.max(0, this.currentIndex - 1);
      } else if (this.dragDeltaX < -threshold) {
        this.currentIndex = Math.min(this.maxIndex, this.currentIndex + 1);
      }
  
      this.dragDeltaX = 0;
      this.updateSlider();
      this.restartAutoplay();
    }
  
    onResize() {
      this.setPerView();
      this.buildDots();
      this.updateSlider();
    }
  
    startAutoplay() {
      if (!this.autoplay || this.maxIndex === 0) return;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(() => this.onNext(), this.autoplaySpeed);
    }
  
    stopAutoplay() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  
    restartAutoplay() {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }
  
  customElements.define('testimonials-slider', TestimonialsSlider);